import React from "react";
import TeamCategoryFormPage from "../components/team/TeamCategoryFormPage";

const TeamCategoryEdit = () => <TeamCategoryFormPage mode="edit" />;

export default TeamCategoryEdit;
